<template>
    <div class="render-box" :style="{width: `${width}px`, height: `${height}px`}">
        <span class="close-btn-part" v-if="showCloseBtn === true" @click="clickReturnBtn">
            <span>×</span>
        </span>

        <div class="label-span">
<!--            <span tkey="請選擇地區">{{i18n.tkey("lang_pls_select_region")}}</span>-->
<!--            <br>-->
            <el-select
                    v-model="selectCountry"
                    filterable
                    :placeholder="i18n.tkey('lang_pls_select_region')"
                    size="large"
                    style=""
                    :disabled="!controlFlag"
                    @change="changeCountry"
            >
                <el-option
                        v-for="item in countryList"
                        :key="item.countrycode"
                        :label="(userInfoRef.lang == 'zh' || userInfoRef.lang == 'szh') ? item.zh : item.en"
                        :value="item.countrycode"
                        :disabled="item.countrycode != 'HK' && item.countrycode != 'CN'"
                />
            </el-select>

            <el-button
                class="goto-btn"
                type="danger"
                size=""
                :disabled="selectCountry == null"
                @click="clickGoBtn"
                tkey="前往"
            >
                {{goBtnLabel}}
            </el-button>
        </div>

<!--        <div class="operation-box">-->
<!--            <el-button class="bigger-btn" type="danger" size="large" :disabled="selectCountry == null" @click="clickGoBtn" tkey="前往">{{goBtnLabel}}</el-button>-->
<!--        </div>-->

        <div class="slider-demo-block">
            <div style="font-weight: 600; font-size: 14px; color: #fefefe; line-height: 2">
                <span tkey="縮放">{{i18n.tkey("lang_zoom")}}</span>
            </div>

            <el-slider v-model="cameraDistance" @input="changeCameraDistance" vertical :step="10" :min="40" :max="150" height="200px" />
        </div>

        <div style="width: 100%; height: 100" ref="threeRenderDom">

        </div>
    </div>
</template>

<script setup>
import {getCurrentInstance, inject, onBeforeUnmount, onMounted, ref, onBeforeMount, toRef, computed} from "vue";
    import myUtil from "@/util/util";
    import * as TWEEN from "@tweenjs/tween.js";
    import {useUserinfo} from "@/stores/userinfo";
    import {countryList} from "@/util/countrycode";
import {usePageinfo} from "@/stores/pageinfo";

    const props = defineProps(["showCloseBtn"])
    const emits = defineEmits(["clickRegion", "clickClose"])

    let { proxy } = getCurrentInstance();
    let THREE = proxy.$THREE;
    const publicPath = process.env.BASE_URL

    const i18n = inject("i18n")

    let camera = null
    let render = null
    let scene = null

    const width = window.innerWidth
    const height = window.innerHeight

    const userInfoRef = toRef(useUserinfo())
    const pageInfoRef = toRef(usePageinfo())

    //纹理贴图加载器TextureLoader
    const texLoader = new THREE.TextureLoader();

    const threeRenderDom = ref(null)

    const clock = new THREE.Clock();
    const FPS = 30; // 指的是 30帧每秒的情况
    // const singleFrameTime = (1/FPS);
    let timeStamp = 0
    // let currTimeStamp = 0
    let mixerUpdateDelta;
    let animationFrameId;

    let pointGroup = null
    let boxGroup = null

    let pointMesh = null
    let unselectedMaterial = null
    let selectedMaterial = null
    let disabledMaterial = null
    let currSelectedMesh = null
    let earthRotationGroup = null

    let rotationY = Math.PI / 180 * 220
    let rotationX = 0
    let pauseTimer = 0
    let pauseFlag = false

    let funcListObj = {}

    let mousedownFlag = false
    let touchPoint = null
    const isMobile = myUtil.isMobile()
    let controlFlag = ref(true)
    //鼠标按下计时
    let mouseDownTimeStamp = 0
    //是否已進入銷毀流程
    let destoryFlag = false

    let interactionList = []
    let interactionObj = {}
    //动画对象
    const animationObjGroup = {}

    const selectCountry = ref(null)

    const cameraDistance = ref(80)

    // const countryList = [
    //     {
    //         longitude: 116.3,
    //         latitude: 39.9,
    //         zh: "中國大陸",
    //         en: "China",
    //         szh: "中国大陆",
    //         countrycode: "CN"
    //     },
    //     {
    //         longitude: 114.15,
    //         latitude: 22.15,
    //         zh: "香港",
    //         en: "HongKong",
    //         szh: "香港",
    //         countrycode: "HK"
    //     },
    //     {
    //         longitude: 121.5144,
    //         latitude: 25.04,
    //         zh: "台灣",
    //         en: "Taiwan",
    //         szh: "台湾",
    //         countrycode: "TW"
    //     },
    //     {
    //         longitude: -74.5,
    //         latitude: 40.5,
    //         zh: "美國",
    //         en: "United States",
    //         szh: "美国",
    //         countrycode: "US"
    //     },
    //     {
    //         longitude: 0.1,
    //         latitude: 51.3,
    //         zh: "英國",
    //         en: "United Kingdom",
    //         szh: "英国",
    //         countrycode: "GB"
    //     },
    //     {
    //         longitude: 151.1,
    //         latitude: -33.51,
    //         zh: "澳洲",
    //         en: "Australia",
    //         szh: "澳大利亚",
    //         countrycode: "AU"
    //     },
    //     {
    //         longitude: -43.11,
    //         latitude: -22.54,
    //         zh: "巴西",
    //         en: "Brazil",
    //         szh: "巴西",
    //         countrycode: "BR"
    //     },
    //     {
    //         longitude: 13.2,
    //         latitude: 52.3,
    //         zh: "德國",
    //         en: "Germany",
    //         szh: "德国",
    //         countrycode: "DE"
    //     },
    //     {
    //         longitude: 139.44,
    //         latitude: 35.41,
    //         zh: "日本",
    //         en: "Japan",
    //         szh: "日本",
    //         countrycode: "JP"
    //     },
    //     {
    //         longitude: -75.43,
    //         latitude: 45.25,
    //         zh: "加拿大",
    //         en: "Canada",
    //         szh: "加拿大",
    //         countrycode: "CA"
    //     },
    //     {
    //         longitude: 106.45,
    //         latitude: -6.08,
    //         zh: "印尼",
    //         en: "Indonesia",
    //         szh: "印度尼西亚",
    //         countrycode: "ID"
    //     },
    //     {
    //         longitude: 103.51,
    //         latitude: 1.18,
    //         zh: "新加坡",
    //         en: "Singapore",
    //         szh: "新加坡",
    //         countrycode: "SG"
    //     },
    //     {
    //         // longitude: 102.42,
    //         // latitude: 4.08,
    //         longitude: 102.42,
    //         latitude: 4.08,
    //         zh: "馬來西亞",
    //         en: "Malaysia",
    //         szh: "马来西亚",
    //         countrycode: "MY"
    //     },
    //
    //
    //
    //
    //
    //     {
    //         longitude: 27.54,
    //         latitude: -26.08,
    //         zh: "南非",
    //         en: "South Africa",
    //         szh: "南非",
    //         countrycode: "ZA"
    //     },
    //     {
    //         longitude: 38.74,
    //         latitude: 9.03,
    //         zh: "埃塞俄比亞",
    //         en: "Ethiopia",
    //         szh: "埃塞俄比拉",
    //         countrycode: "ET"
    //     },
    //     {
    //         longitude: 7.11,
    //         latitude: 9.12,
    //         zh: "尼日利亞",
    //         en: "Nigeria",
    //         szh: "尼日利亚",
    //         countrycode: "NG"
    //     },
    //     {
    //         longitude: 3.13,
    //         latitude: 36.42,
    //         zh: "阿爾及利亞",
    //         en: "Algeria",
    //         szh: "阿尔及利亚",
    //         countrycode: "DZ"
    //     },
    //     {
    //         longitude: -7.37,
    //         latitude: 33.36,
    //         zh: "摩洛哥",
    //         en: "Morocco",
    //         szh: "摩洛哥",
    //         countrycode: "MA"
    //     },
    //     {
    //         longitude: 31.17,
    //         latitude: 30,
    //         zh: "埃及",
    //         en: "Egypt",
    //         szh: "埃及",
    //         countrycode: "EG"
    //     },
    //     {
    //         longitude: 35.4,
    //         latitude: -6.1,
    //         zh: "坦桑尼亞",
    //         en: "Tanzania",
    //         szh: "坦桑尼亚",
    //         countrycode: "TZ"
    //     },
    //     {
    //         longitude: 2.2,
    //         latitude: 48.51,
    //         zh: "法國",
    //         en: "France",
    //         szh: "法国",
    //         countrycode: "FR"
    //     },
    //     {
    //         longitude: 32.54,
    //         latitude: 40.02,
    //         zh: "土耳其",
    //         en: "Turkey",
    //         szh: "土耳其",
    //         countrycode: "TR"
    //     },
    //     {
    //         longitude: 46.44,
    //         latitude: 24.39,
    //         zh: "沙特阿拉伯",
    //         en: "Saudi Arabia",
    //         szh: "沙特阿拉伯",
    //         countrycode: "SA"
    //     },
    //     {
    //         longitude: 174.45,
    //         latitude: -36.55,
    //         zh: "紐西蘭",
    //         en: "New Zealand",
    //         szh: "新西兰",
    //         countrycode: "NZ"
    //     },
    //     {
    //         longitude: 37.37,
    //         latitude: 55.45,
    //         zh: "俄羅斯",
    //         en: "Russian Federation",
    //         szh: "俄罗斯",
    //         countrycode: "RU"
    //     },
    //     {
    //         longitude: 27.3,
    //         latitude: 53.51,
    //         zh: "白俄羅斯",
    //         en: "Belarus",
    //         szh: "白俄罗斯",
    //         countrycode: "BY"
    //     },
    //     {
    //         longitude: 20.28,
    //         latitude: 44.49,
    //         zh: "塞爾維亞",
    //         en: "Serbia",
    //         szh: "塞尔维亚",
    //         countrycode: "RS"
    //     },
    //     {
    //         longitude: 19.15,
    //         latitude: 47.26,
    //         zh: "匈牙利",
    //         en: "Hungary",
    //         szh: "匈牙利",
    //         countrycode: "HU"
    //     },
    //     {
    //         longitude: 68.51,
    //         latitude: 38.38,
    //         zh: "塔吉克",
    //         en: "Tajikistan",
    //         szh: "塔吉克斯坦",
    //         countrycode: "TJ"
    //     },
    //     {
    //         longitude: 71.3,
    //         latitude: 51.1,
    //         zh: "哈薩克",
    //         en: "Kazakhstan",
    //         szh: "哈萨克斯坦",
    //         countrycode: "KZ"
    //     },
    //     {
    //         longitude: 51.3,
    //         latitude: 35.45,
    //         zh: "伊朗",
    //         en: "Iran",
    //         szh: "伊朗",
    //         countrycode: "IR"
    //     },
    //     {
    //         longitude: 77.13,
    //         latitude: 28.37,
    //         zh: "印度",
    //         en: "India",
    //         szh: "印度",
    //         countrycode: "IN"
    //     },
    //     {
    //         longitude: 79.52,
    //         latitude: 6.55,
    //         zh: "斯里蘭卡",
    //         en: "Sri Lanka",
    //         szh: "斯里兰卡",
    //         countrycode: "LK"
    //     },
    //     {
    //         longitude: 73.08,
    //         latitude: 33.4,
    //         zh: "巴基斯坦",
    //         en: "Pakistan",
    //         szh: "巴基斯坦",
    //         countrycode: "PK"
    //     },
    //     {
    //         longitude: 100.29,
    //         latitude: 13.5,
    //         zh: "泰國",
    //         en: "Thailand",
    //         szh: "泰国",
    //         countrycode: "TH"
    //     },
    //     {
    //         longitude: 90.24,
    //         latitude: 23.51,
    //         zh: "孟加拉",
    //         en: "Bangladesh",
    //         szh: "孟加拉",
    //         countrycode: "BD"
    //     },
    //     {
    //         longitude: 12.37,
    //         latitude: 41.52,
    //         zh: "意大利",
    //         en: "Italy",
    //         szh: "意大利",
    //         countrycode: "IT"
    //     },
    //     {
    //         longitude: -3.42,
    //         latitude: 40.26,
    //         zh: "西班牙",
    //         en: "Spain",
    //         szh: "西班牙",
    //         countrycode: "ES"
    //     },
    //     {
    //         longitude: -9.05,
    //         latitude: 38.42,
    //         zh: "葡萄牙",
    //         en: "Portugal",
    //         szh: "葡萄牙",
    //         countrycode: "PT"
    //     },
    // ]

    const goBtnLabel = computed(() => {
        let name = i18n.tkey("lang_pls_select_region")

        if (null != selectCountry.value){
            let obj = {}

            for (let i=0; i<countryList.length; i++){
                const v = countryList[i]

                if (v.countrycode == selectCountry.value){
                    obj = v
                }
            }

            if (userInfoRef.value.lang == 'zh' || userInfoRef.value.lang == 'szh'){
                name = `${i18n.tkey("lang_goto") } ${obj.zh}`
            }else{
                name = `${i18n.tkey("lang_goto") } ${obj.en} `
            }

            name = i18n.tkey("lang_goto")
        }

        return name
    })


    function initPointMesh(){
        const geometry = new THREE.CircleGeometry(0.35)
        // const map = texLoader.load(`${publicPath}textures/img/point.png`)
        // map.colorSpace = THREE.SRGBColorSpace
        const material = new THREE.MeshBasicMaterial({
            color: 0xff0000,
            side: THREE.DoubleSide,
            transparent: true,
            // map: map,
        })

        const material2 = new THREE.MeshBasicMaterial({
            color: 0x67C23A,
            side: THREE.DoubleSide,
            transparent: true,
            // map: map,
        })

        const material3 = new THREE.MeshBasicMaterial({
            color: 0x606266,
            side: THREE.DoubleSide,
            transparent: true,
            // map: map,
        })

        const mesh = new THREE.Mesh(geometry, material)

        pointMesh = mesh
        selectedMaterial = material2
        unselectedMaterial = material
        disabledMaterial = material3
    }

    function createBackground() {
        const geometry = new THREE.PlaneGeometry(94.5, 94.5)
        const map = texLoader.load(`${publicPath}textures/img/earth_glow.png`)
        map.center.set(0.5, 0.5)
        map.rotation = -90 * Math.PI / 180
        const material = new THREE.MeshBasicMaterial({
            map: map,
            transparent: true
        })
        const mesh = new THREE.Mesh(geometry, material)
        mesh.rotation.z = Math.PI / 2

        scene.add(mesh)

        const map2 = texLoader.load(`${publicPath}textures/img/earth_glow_light.png`)
        map2.center.set(0.5, 0.5)
        map2.rotation = -90 * Math.PI / 180
        const material2 = new THREE.MeshBasicMaterial({
            map: map2,
            transparent: true
        })
        const mesh2 = new THREE.Mesh(geometry, material2)
        mesh2.rotation.z = Math.PI / 2

        mesh2.position.z = 0.5
        //
        // mesh2.scale.x = 0.7
        // mesh2.scale.y = 0.7
        // mesh2.scale.z = 0.7

        scene.add(mesh2)
    }

    function createEarth(){
        const geometry = new THREE.SphereGeometry(30, 64, 64)
        const map = texLoader.load(`${publicPath}textures/earth_atmos.jpg`)
        const material = new THREE.MeshBasicMaterial({
            map: map
        })
        const mesh = new THREE.Mesh(geometry, material)
        mesh.rotation.y = Math.PI / -2
        // mesh.rotation.y = Math.PI

        const group = new THREE.Group()
        group.add(mesh)
        pointGroup = group

        const group2 = new THREE.Group()
        group2.add(group)
        // group2.rotation.y = Math.PI / 4 * -2
        earthRotationGroup = group2

        scene.add(group2)
        boxGroup = group2

        countryList.forEach((v, i) => {
            createMapPosition(v)
        })
		scene.background = new THREE.TextureLoader().load( `${publicPath}textures/img/bg.jpg`, function ( texture ) {
		  texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
		  render.setClearColor(0x000000, 0); //设置背景色
		} );

        funcListObj["rotateEarthFunc"] = rotationEarth

        interactionList.push(mesh)
        interactionObj[mesh.uuid] = [{
            callback: () => {
                console.log("earth")
            }
        }]

        // rotateToPosition(-74, 40.7)

        // const gui = new GUI()
        // gui.add(group2.rotation, "x").step(0.01)
        // gui.add(group2.rotation, "y").step(0.01)
        // gui.add(group2.rotation, "z").step(0.01)
        //
        // const gui2 = new GUI()
        // gui2.add(camera.position, "x").step(0.01)
        // gui2.add(camera.position, "y").step(0.01)
        // gui2.add(camera.position, "z").step(0.01)
    }

    function createMapPosition(obj) {
        const temp = {
            longitude: null,
            latitude: null,
            zh: null,
            en: null,
            szh: null,
            countrycode: null
        }

        Object.assign(temp, obj)

        if (null != temp.countrycode && null != temp.longitude && null != temp.latitude){
            const mesh = pointMesh.clone()
            pointGroup.add(mesh)

            if (temp.countrycode != "HK" && temp.countrycode != "CN"){
                mesh.material = disabledMaterial
            }

            const position = calcPosition(temp.longitude, temp.latitude)

            mesh.position.x = position.x
            mesh.position.y = position.y
            mesh.position.z = position.z
            mesh.lookAt(pointGroup.position)
            obj.mesh = mesh

            createNamePad(temp, mesh)

        }

    }

    function loadImage(url) {
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.src = url;
            img.remove()
        })
    }

    function createNamePad(data, group) {
        let text = data.en

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
            text = data.zh
        }

        // Promise.all([
        //     loadImage(process.env.BASE_URL + "mytextures/name_pad.png")
        // ]).then((images) => {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext('2d')

            canvas.width = 120
            canvas.height = 16
            //制作矩形
            // ctx.fillStyle = "transparent";
            // ctx.fillRect(0, 0, 120, 60)

            //设置文字
            ctx.fillStyle = "red";
            ctx.font = `normal 14px "楷体"`
            canvas.width = ctx.measureText(text).width + 5
            canvas.height = 16
            // ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height)
            ctx.fillStyle = "transparent";
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.font = `normal 14px "楷体"`
            ctx.strokeStyle = 'black'
            ctx.lineWidth = 2; // 设置边框宽度
            ctx.strokeText(text, 0, 14)
            ctx.fillStyle = "#fefefe";
            ctx.fillText(text, 0, 14)

            //生成图片
            let url = canvas.toDataURL('image/png');
            //将图片构建到纹理中
            const geometry = new THREE.PlaneGeometry(canvas.width / 12, canvas.height / 12)
            const map = texLoader.load(url)
            map.colorSpace = THREE.SRGBColorSpace
            const material = new THREE.MeshBasicMaterial({
                map: map,
                // side: THREE.DoubleSide,
                opacity: 1,
                transparent: true
            })

            const mesh = new THREE.Mesh(geometry, material)

            mesh.position.x = (0.5 + canvas.width / 20) * -1
            mesh.lookAt(pointGroup.position)
            mesh.rotation.y = Math.PI

            group.add(mesh)

            if (data.countrycode != "HK" && data.countrycode != "CN"){
                return
            }

            interactionList.push(mesh)
            interactionObj[mesh.uuid] = [{
                callback: () => {
                    controlFlag.value = false

                    pauseFlag = true
                    pauseTimer = -9999999

                    if (null != currSelectedMesh){
                        currSelectedMesh.material = unselectedMaterial
                    }

                    currSelectedMesh = mesh.parent
                    currSelectedMesh.material = selectedMaterial

                    rotateToPosition(data.longitude, data.latitude, () => {
                        // myUtil.confirmWarning(`${i18n.tkey("lang_select_region_confirm")} ${text} ?`, () => {
                            // pauseTimer = 3
                            controlFlag.value = true
                            // mesh.parent.visible = false
                            //
                            // const tween = new TWEEN.Tween(camera.position)
                            //     .to({z: 40}, 2000)
                            //     .start()
                            //     .easing(TWEEN.Easing.Sinusoidal.In)
                            //     .onComplete(() => {
                            //         emits("clickRegion", data.countrycode)
                            //     })
                            //     .onUpdate(() => {
                            //
                            //     })
                            //
                            // animationObjGroup["goRegion"] = tween

                            selectCountry.value = data.countrycode


                        // }, () => {
                        //     pauseTimer = 3
                        //     controlFlag.value = true
                        // })
                    })


                }
            }]


        // })
    }

    function calcPosition(longitude, latitude) {
        const angle = Math.PI / 180
        // longitude = longitude + 45

        longitude = calcRealAngle(longitude)
        latitude = calcRealAngle(latitude)

        const phi = (90 + longitude) * (angle)

        const theta = (90 - latitude) * (angle)

        let camera_x = -30.1 * Math.sin(theta) * Math.cos(phi)

        let camera_y = 30.1 * Math.cos(theta)

        let camera_z = 30.1 * Math.sin(theta) * Math.sin(phi)

        return {
            x: camera_x,
            y: camera_y,
            z: camera_z
        }


    }

    function rotateToPosition(longitude, latitude, callback) {
        const angle = Math.PI / 180
        const rotateY = angle * calcRealAngle(longitude) * -1
        const rotatex = angle * calcRealAngle(latitude)


        const tween = new TWEEN.Tween(boxGroup.rotation)
            .to({x: rotatex, y: rotateY}, 500)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.InOut)
            .onComplete(() => {
                rotationY = rotateY
                rotationX = rotatex
                delete animationObjGroup["moveToPosition"]

                callback()
            })
            .onUpdate(() => {
                rotationY = boxGroup.rotation.y
                rotationX = boxGroup.rotation.x
            })

        animationObjGroup["moveToPosition"] = tween

        // boxGroup.rotation.y = rotateY
        // boxGroup.rotation.x = rotatex
        //
        // rotationY = rotateY
        // rotationX = rotatex
    }

    function calcRealAngle(angle) {
        return Math.floor(angle) + angle % 1 / 60
    }

    function rotationEarth() {
        if (pauseFlag){
            pauseTimer += mixerUpdateDelta

            if (pauseTimer > 5){
                pauseTimer = 0
                pauseFlag = false
            }

        }else{
            pauseTimer = 0
            rotationY += 0.001

            if (rotationY > Math.PI * 2){
                rotationY -= Math.PI * 2
            }

            if (rotationX != 0){
                if (rotationX < 0){
                    rotationX += 0.0001
                }else{
                    rotationX -= 0.0001
                }
            }
        }

        earthRotationGroup.rotation.y = rotationY
        earthRotationGroup.rotation.x = rotationX
    }

    function renderFrame() {
        if (destoryFlag){
            return
        }

        // stats.update();
        mixerUpdateDelta = clock.getDelta()

        // getSceneModelFaceNum(scene)
        timeStamp += mixerUpdateDelta;
        render.render(scene, camera)

        for (const v in funcListObj){
            if (typeof funcListObj[v] === "function"){
                funcListObj[v]()
            }
        }

        animationFrameId = requestAnimationFrame(renderFrame)

    }

    function initValue(){
        scene = new THREE.Scene()
        // camera = new THREE.PerspectiveCamera(45, 8.0 / 5.0, 0.1, 600)
        const fov = myUtil.isMobile() ? 60 : 45

        camera = new THREE.PerspectiveCamera(fov, 8.0 / 3.0, 1, 700)
        camera.aspect = (width) / (height);
        camera.updateProjectionMatrix();
        render = new THREE.WebGLRenderer({
            // logarithmicDepthBuffer: true, // 设置对数深度缓冲区，优化深度冲突问题
            antialias: true, //开启抗锯齿,
            alpha: true,
            precision: 'mediump',
            powerPreference: "high-performance",
        })

        render.gammaInput = true;
        render.gammaOutput = true;//inear转gamma
        render.toneMapping = THREE.ACESFilmicToneMapping
        render.useLegacyLights = true

        render.setPixelRatio(window.devicePixelRatio); //设置屏幕像素比
        // render.setPixelRatio(2); //设置屏幕像素比
        render.setClearColor(0x000000, 1); //设置背景色
		// 设置背景貼圖，这里以一个纹理为例
		// var texture = new THREE.TextureLoader().load('@/assets/bg_xinkon.gif');
		

        render.setSize(width, height);
        render.shadowMap.enabled = true //渲染器開啟陰影渲染
        render.shadowMap.type = THREE.PCFSoftShadowMap;
        render.render(scene, camera);

        threeRenderDom.value.innerHTML = ""
        threeRenderDom.value.appendChild(render.domElement);


        if (isMobile){
            camera.position.set(0,0,80);
        }else{
            camera.position.set(0,0,100);
        }

        camera.lookAt(new THREE.Vector3(0,0,0));

        if (myUtil.isMobile()){
            threeRenderDom.value.addEventListener("touchmove", mouseMoveEvent)

            threeRenderDom.value.addEventListener("touchstart", mouseDownEvent)

            threeRenderDom.value.addEventListener("touchend", mouseUpEvent)

        }else{
            threeRenderDom.value.addEventListener("mousemove", mouseMoveEvent)

            threeRenderDom.value.addEventListener("mousedown", mouseDownEvent)

            threeRenderDom.value.addEventListener("mouseup", mouseUpEvent)

            threeRenderDom.value.addEventListener("click", mouseClickEvent)
        }

        funcListObj['updateTween'] = updateTween
    }

    function mouseDownEvent(e){
        if (!controlFlag.value){
            return;
        }

        mouseDownTimeStamp = e.timeStamp

        // if (!isMobile){
            mousedownFlag = true
        // }

        // moveFlag = true
        //
        if (isMobile){
            if (null == e.touches){
                return
            }

            touchPoint = e.touches[0]
        }
        //
        // var obj = getMousePosition(e)
        //
        // obj.direction.setY(0)
        // moveVector3.copy(obj.direction)
    }

    function mouseUpEvent(e){
        if (isMobile){
            if (controlFlag.value){
                const temp = {
                    touches: [
                        touchPoint
                    ]
                }
                mouseClickEvent(temp)
            }
        }

        mousedownFlag = false
        touchPoint = null
    }

    function mouseMoveEvent(e){

        if (!mousedownFlag)
            return

        if (!controlFlag.value){
            return;
        }

        // if (isMobile){
        //     return;
        // }

        // if (nippleFlag){
        //     return;
        // }

        if (isMobile){

            if (null == e.changedTouches){
                return
            }

            rotationY -= (touchPoint.clientX - e.changedTouches[0].clientX) / 300;
            rotationX -= (touchPoint.clientY - e.changedTouches[0].clientY) / 1200;
            touchPoint = e.changedTouches[0]

            pauseFlag = true
            pauseTimer = 0
        }else{
            rotationY += e.movementX / 300;
            rotationX += e.movementY / 1200;

            pauseFlag = true
            pauseTimer = 0
        }

    }

    function mouseClickEvent(e){
        if (!controlFlag.value){
            return;
        }

        if (e.timeStamp - mouseDownTimeStamp > 1000){
            return;
        }

        const obj = getMousePosition(e, interactionList)

        if (null == obj){
            return;
        }

        if (obj.intersects != null && obj.intersects.length > 0){
            const intersect = obj.intersects[0]
            if (intersect.distance < 9999999){
                const uuid = intersect.object.uuid
                const temp = interactionObj[uuid]

                if (temp.length > 0){
                    for (const item in temp){
                        const obj = temp[item]
                        if (obj != null && null != obj.callback && typeof obj.callback === "function"){
                            obj.callback()
                        }
                    }
                }else{
                    if (temp != null && null != temp.callback && typeof temp.callback === "function"){
                        temp.callback()
                    }
                }
            }
        }
    }

    function getMousePosition(e, objList){
        const obj = {
            position: null,
            direction: null,
            intersects: []
        }

        let px
        let py

        if (isMobile){
            try {
                px = e.touches[0].clientX - 10;
                py = e.touches[0].clientY - 10;
            }catch (e) {
                return
            }
        }else{
            px = e.clientX - 10;
            py = e.clientY - 10;
        }

        //屏幕坐标px、py转标准设备坐标x、y
        //width、height表示canvas画布宽高度
        const x = (px / width) * 2 - 1;
        const y = -(py / height) * 2 + 1;

        //创建一个射线投射器`Raycaster`
        const raycaster = new THREE.Raycaster();

        raycaster.setFromCamera(new THREE.Vector2(x, y), camera);

        // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
        const intersects = raycaster.intersectObjects(objList);

        if (intersects != null && intersects.length > 0){
            obj.intersects = intersects
            obj.position = intersects[0].point
        }

        // if (obj.intersects.length > 0){
        //     const point = obj.intersects[0].point
        //     const vec3 = new THREE.Vector3()
        //
        //     vec3.x = point.x - meshGroup.position.x
        //     vec3.z = point.z - meshGroup.position.z
        //
        //     vec3.normalize()
        //     obj.direction = vec3
        // }else{
            obj.direction = raycaster.ray.direction
        // }



        return obj
    }

    function updateTween() {
        for( let i in animationObjGroup){
            animationObjGroup[i].update()
        }
    }

    function changeCountry(value){
        pauseFlag = true
        pauseTimer = -999999

        for (let i=0; i<countryList.length; i++){
            const obj = countryList[i]

            if (obj.countrycode == value){
                if (null != currSelectedMesh){
                    currSelectedMesh.material = unselectedMaterial
                }

                currSelectedMesh = obj.mesh
                currSelectedMesh.material = selectedMaterial

                rotateToPosition(obj.longitude, obj.latitude, () => {
                    controlFlag.value = true
                    pauseFlag = true
                    pauseTimer = 0
                })
                break;
            }

        }
    }

    function clickGoBtn(){
        if (null == selectCountry.value){
            return
        }

        if (selectCountry.value != userInfoRef.value.selectCountry){
            pageInfoRef.value.showWelcomeAnimation = true
        }

        pauseFlag = true
        pauseTimer = -9999999
        controlFlag.value = false

        const tween = new TWEEN.Tween(camera.position)
            .to({z: 35}, 1500)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.In)
            .onComplete(() => {
                delete animationObjGroup["goRegion"]
            })
            .onUpdate(() => {

            })

        animationObjGroup["goRegion"] = tween

        setTimeout(() => {
            let obj = {}

            countryList.forEach((v, i) => {
                if (v.countrycode == selectCountry.value){
                    obj = v
                }
            })

            emits("clickRegion", obj)
        }, 1250)
    }

    function changeCameraDistance(){
        camera.position.z = cameraDistance.value
    }

    function clickReturnBtn(){
        emits("clickClose")
    }

    onBeforeMount(() => {

    })

    onMounted(() => {
        initValue()
        initPointMesh()
        createBackground()
        createEarth()

        if (myUtil.isEmpty(userInfoRef.value.selectCountry)){
            selectCountry.value = "HK"
        }else{
            selectCountry.value = userInfoRef.value.selectCountry
        }

        setTimeout(() => {
            changeCountry(selectCountry.value)
        }, 2000)

        setTimeout(() => {
            renderFrame()
        }, 1000)


    })

    //清除three.js占用的内存
    onBeforeUnmount(() => {
        destoryFlag = true
        console.log("开始清除内存")

        threeRenderDom.value.removeEventListener('touchmove', mouseMoveEvent)
        threeRenderDom.value.removeEventListener('touchstart', mouseDownEvent)
        threeRenderDom.value.removeEventListener('touchend', mouseUpEvent)
        threeRenderDom.value.removeEventListener('mousemove', mouseMoveEvent)
        threeRenderDom.value.removeEventListener('mousedown', mouseDownEvent)
        threeRenderDom.value.removeEventListener('mouseup', mouseUpEvent)
        threeRenderDom.value.removeEventListener('click', mouseClickEvent)

        // stats.domElement.remove()

        try {
            funcListObj = {}

            cancelAnimationFrame(animationFrameId); // animationFrameId = requestAnimationFrame(this.render);
            render.dispose();
            render.forceContextLoss();
            render.content = null;
            let gl = render.domElement.getContext("webgl");
            if (gl && gl.getExtension("WEBGL_lose_context")) {
                gl.getExtension("WEBGL_lose_context").loseContext();
            }
            render = null;
            camera = null;
            scene.traverse((child) => {
                try {
                    if (child.material && null != child.material) {
                        child.material.dispose();
                    }
                }catch (e) {
                    console.log(e)
                }

                try {
                    if (child.geometry && null != child.geometry) {
                        child.geometry.dispose();
                    }
                }catch (e) {
                    console.log(e)
                }


                child = null;
            });
            scene = null;

            THREE.Cache.clear()
        } catch (e) {
            console.error('Failed to destroy threejs', e);
        }

        //刪除render dom
        threeRenderDom.value.innerHTML = ""
    })

</script>

<style scoped>
    .render-box {
        position: relative;
    }

    .label-span {
        width: 100%;
        top: 10px;
        left: 0;
        text-align: center;
        line-height: 2;
        color: #fefefe;
        font-size: 20px;
        position: absolute;
        font-weight: 600;
    }

    .close-btn-part {
        position: absolute;
        font-size: 20px;
        right: 10px;
        top: 10px;
        color: #fefefe;
        font-weight: 600;
        cursor: pointer;
        z-index: 10;
    }

    .operation-box {
        width: 100%;
        bottom: 0;
        left: 0;
        text-align: center;
        line-height: 3;
        color: #fefefe;
        font-size: 20px;
        position: absolute;
        font-weight: 600;
        transition: 0.5s all ease;
    }

    .slider-demo-block{
        position: absolute;
        left: 10px;
        bottom: 30px;
    }

    .bigger-btn {
        padding: 18px 25px;
        height: 50px;
    }

    .goto-btn {
        margin-left: 10px;
    }
</style>
